module.exports = __webpack_public_path__ + "img/Event_6.50005b5c.jpg";